import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';

const fieldId = 'sst-business-justification';

const validator = () => null;

const vFParams = {
  fieldTitle: 'Business justification',
};

const sstBusinessJustification = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE,
};

export { sstBusinessJustification };
